$(document).ready(function () {
  // if variation is select value
  $(".single_selector").on("change", function () {
    let variantName = "";
    $(".single_selector").each(function (e) {
      variantName += e != 0 ? "-" : "";
      variantName += $(this).val();
    });

    $("#productSelect option").each(function () {
      var txt = $.trim($(this).text());
      if (txt == variantName) {
        $(this).parent().val($(this).val());
        var id = $(this).val();
        var price = $(this).data("price");
        var src = $(this).data("img");
        var compare_price = $(this).data("compare");
        var available = $(this).data("available");

        if (typeof src !== "undefined") {
          $(".is-active").find("img").attr("src", src).attr("srcset", src);
        }

        $("#product_id").val(id);
        if (available == true) {
          $(".product-btn").removeClass("sold_out").text("Add To Cart");
        } else {
          $(".product-btn").addClass("sold_out").text("Sold Out");
        }
      }
    });
  });

  // if variation is radio value
  $(".option_input").on("change", function () {
    let optionName = "";
    $("input:radio.option_input:checked").each(function (e) {
      optionName += e != 0 ? "-" : "";
      optionName += $(this).val();
    });

    $("#productSelect option").each(function () {
      var txt = $.trim($(this).text());
      if (txt == optionName) {
        $(this).parent().val($(this).val());
        var id = $(this).val();
        var price = $(this).data("price");
        var compare_price = $(this).data("compare");
        var available = $(this).data("available");
        var src = $(this).data("img");

        if (typeof src !== "undefined") {
          $(".is-active").find("img").attr("src", src).attr("srcset", src);
        }

        $("#product_id").val(id);
        if (available == true) {
          $(".atc-text").text("Add To Cart");
          $(".product-btn").removeClass("sold_out");
        } else {
          $(".atc-text").text("Sold Out");
          $(".product-btn").addClass("sold_out");
        }
      }
    });
  });

  // quantity selector
  $(".product-qty-plus").on("click", function () {
    var qty = parseInt($(this).prev().val());
    qty += 1;
    $(".product_qty").val(qty);
    $(this).prev().val(qty);
  });

  $(".product-qty-minus").on("click", function () {
    var qty = parseInt($(this).next().val());
    if (qty > 1) {
      qty -= 1;
      $(".product_qty").val(qty);
      $(this).next().val(qty);
    }
  });

  $(".product-input-qty").on("keyup", function () {
    var qty = parseInt($(this).val());
    if (qty > 1) {
      $("#product_qty").val(qty);
    }
  });

  $(".lens-product-selector").on("change", function () {
    var lensId = $(this).val();
    $(".lens_id").val(lensId);
  });

  // add to cart

  $(".addToCart, .buyNow").on("click", function (e) {
    e.preventDefault();
  
    var mainForm = $("#product_form").serializeArray();
    var items = [];
  
    var mainProduct = {
      id: $("#product_id").val(),
      quantity: $("#product_qty").val() || 1,
      properties: {}
    };
  
    // Add custom properties
    mainForm.forEach(function (field) {
      if (field.name.startsWith('properties[') && field.value.trim() !== '') {
        var propName = field.name.match(/properties\[(.*)\]/)[1];
        mainProduct.properties[propName] = field.value;
      }
    });
  
    items.push(mainProduct);
  
    var isPowerLens = $(".choose-lens-power").is(":checked");
    var prescriptionType = $("#prescription_selector").val();
    var lensVariantId = "";
  
    if (isPowerLens) {
      if (prescriptionType === "zero Power") {
        lensVariantId = $("#lens_selector").val();
      } else if (prescriptionType === "unifocal") {
        lensVariantId = $("#lens_selector_2").val();
      } else if (prescriptionType === "progressive") {
        lensVariantId = $("#lens_selector_3").val();
      }
  
      if (lensVariantId) {
        items.push({
          id: lensVariantId,
          quantity: 1
        });
      }
    }

    var type = $(this).data('type');
  
    // Ajax Add to Cart
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: JSON.stringify({ items: items }),
      dataType: "json",
      contentType: "application/json",
      success: function (data) {

        console.log('type ' + type);
        
        if(type == 'add') {
          $("body").addClass("cartshown");
          cart_item_update();
        }else if(type == 'buy') {
          window.location.href = "/checkout";
        }

        
       
      },
      error: function (err) {
        console.error("Add to cart error:", err);
      }
    });
  });  
  

    
  // add to cart
  $(".buyNowdd").on("click", function (e) {
    e.preventDefault();
    var product_id = $("#product_id").val();
    var product_qty = $(".product_qty").val();
    const form = $(".product_qty").closest("form");
    const formData = new FormData(this.form);
    var lens_id = $(".lens_id").val();

    let properties = {};
    for (const pair of formData.entries()) {
      if (!pair[0].includes("properties")) {
        continue;
      }
      const propertyName = pair[0].replace("properties[", "").slice(0, -1);
      properties[propertyName] = pair[1];
    }
    if (lens_id != "") {
      var items = [
        { id: product_id, quantity: product_qty, properties: properties },
        { id: lens_id, quantity: 1, properties: properties },
      ];
    } else {
      var items = [
        { id: product_id, quantity: product_qty, properties: properties },
      ];
    }

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: { items },
      dataType: "json",
      success: function (data) {
        window.location.href = "/checkout";
      },
      error: function (err) {
        console.log("Error");
      },
    });
  });
});

function cart_item_update() {
  fetch("/?section_id=cart-drawer")
    .then((reponse) => reponse.text())
    .then((cartData) => {
      var cart_html = $(cartData);
      var cart_items = $(".cart-drawer-items", cart_html);
      var cart_footer = $(".cart-footer-content", cart_html);
      var cart_progress = $(".cart-progress", cart_html);
      $(".cart-drawer-items").replaceWith(cart_items);
      $(".cart-footer-content").replaceWith(cart_footer);
      $(".cart-progress").replaceWith(cart_progress);
    });

  $.getJSON("/cart.js", function (cart) {
    var total_items = cart.item_count;
    $(".cart-count-bubble span").text(total_items);
  });
}
